import React, { useEffect, useState } from 'react';
import { TrackShell, TrackStatus, TrackMap, TrackSpots, TrackRider, TrackInfo, TrackNotice, useTrackOrder } from '../components/track';

// 고객 배송조회 — /t/:token. 링크가 살아 있으면 현황 카드·지도·출발/도착·기사·접수 정보를 보여 주고 진행 중이면 20초마다 갱신한다
function TrackPage({ match }) {
  const token = match.params.token;
  const { status, order, refresh } = useTrackOrder(token);
  const [mapFailed, setMapFailed] = useState(false);

  useEffect(() => {
    const prev = document.title;
    document.title = '퀴노스 배송조회';
    return () => { document.title = prev; };
  }, []);

  return (
    <TrackShell>
      {status === 'loading' && <TrackNotice kind="loading" />}
      {status === 'invalid' && <TrackNotice kind="invalid" />}
      {status === 'error' && <TrackNotice kind="error" onRetry={refresh} />}
      {status === 'ok' && !order && <TrackNotice kind="pending" />}
      {status === 'ok' && order && (
        <React.Fragment>
          <TrackStatus order={order} />
          {order.map && !mapFailed && order.phase !== 'cancelled' && <TrackMap map={order.map} onError={() => setMapFailed(true)} />}
          <TrackSpots from={order.from} to={order.to} />
          <TrackRider rider={order.rider} express={order.express} />
          <TrackInfo order={order} />
        </React.Fragment>
      )}
    </TrackShell>
  );
}

export default TrackPage;
